import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getQueryParams = function getQueryParams() {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return {};
  }

  var url = window.location.href;
  var index = url.indexOf('?');

  if (index === -1) {
    return {};
  }

  var hashIndex = url.indexOf('#');

  if (hashIndex > 0) {
    url = url.slice(0, hashIndex);
  }

  var queryString = url.substr(index + 1, url.length);
  var keyValueStrings = queryString.split('&');
  return keyValueStrings.reduce(function (paramObj, currentKvString) {
    var kvPair = currentKvString.split('=');
    var paramKey = decodeURIComponent(kvPair[0]);
    var paramValue = kvPair.length < 2 ? '1' : decodeURIComponent(kvPair[1]);
    return _objectSpread(_objectSpread({}, paramObj), {}, _defineProperty({}, paramKey, paramValue));
  }, {});
};

export default getQueryParams;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/getQueryParamObject/index.js
// module id = 2013
// module chunks = 12